
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class IrvBasvuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "IrvBasvuruSave";
    super(baseUrl);
  }


  saveIrvBasvuruSave(request: IrvBasvuruRequest){
    
    return this.post("", request, true);
   
  }

}
export default new IrvBasvuruAPI();
class IrvBasvuruRequest {
 
    basvuruTuruId?:number;
    sicilKodu?:number;
    vergiYili?:number;
    ilanBaslamaTarihi?:string;
    ilanBitisTarihi?:string;
    butceGelirId?:number;
    yerKodu?:number;
    mahalleKodu?:number;
    caddeSokakKodu?:number;
    kapiNo?:number;
    altKapiNo?:string;
    daireNo?:number;
    altDaireNo?:string;
    blokKatNo?:string;
    siteApartmanAdi?:string;
    pafta?:string;
    ada?:number;
    parsel?:number;
    aracPlaka?:string;
    aracSaseNo?:string;
    faaliyetKodu?:number;
    sponsorFirmaKodu?:number;
    eni?:number;
    boyu?:number;
    kacYonlu?:number;
    kacAdet?:number;
    adetM2?:string;
    aciklama?:string;
    captchaToken?: string;


  
  constructor(
basvuruTuruId?: number,
sicilKodu?: number,
vergiYili?: number,
ilanBaslamaTarihi?: string,
ilanBitisTarihi?: string,
butceGelirId?: number,
yerKodu?: number,
mahalleKodu?: number,
caddeSokakKodu?: number,
kapiNo?: number,
altKapiNo?: string,
daireNo?: number,
altDaireNo?: string,
blokKatNo?: string,
siteApartmanAdi?: string,
pafta?: string,
ada?: number,
parsel?: number,
aracPlaka?: string,
aracSaseNo?: string,
faaliyetKodu?: number,
sponsorFirmaKodu?: number,
eni?: number,
boyu?: number,
kacYonlu?: number,
kacAdet?: number,
adetM2?: string,
aciklama?: string,
captchaToken?: string

    ) {
   
        this.basvuruTuruId = basvuruTuruId;
        this.sicilKodu = sicilKodu;
        this.vergiYili = vergiYili;
        this.ilanBaslamaTarihi = ilanBaslamaTarihi;
        this.ilanBitisTarihi = ilanBitisTarihi;
        this.butceGelirId = butceGelirId;
        this.yerKodu = yerKodu;
        this.mahalleKodu = mahalleKodu;
        this.caddeSokakKodu = caddeSokakKodu;
        this.kapiNo = kapiNo;
        this.altKapiNo = altKapiNo;
        this.daireNo = daireNo;
        this.altDaireNo = altDaireNo;
        this.blokKatNo = blokKatNo;
        this.siteApartmanAdi = siteApartmanAdi;
        this.pafta = pafta;
        this.ada = ada;
        this.parsel = parsel;
        this.aracPlaka = aracPlaka;
        this.aracSaseNo = aracSaseNo;
        this.faaliyetKodu = faaliyetKodu;
        this.sponsorFirmaKodu = sponsorFirmaKodu;
        this.eni = eni;
        this.boyu = boyu;
        this.kacYonlu = kacYonlu;
        this.kacAdet = kacAdet;
        this.adetM2 = adetM2;
        this.aciklama = aciklama;
        this.captchaToken = captchaToken;

      

  }
}
export { IrvBasvuruRequest };
/*
*/



